import http from '../../utils/http';

export default {
    /**
     * 登录
     *
     * @param {*} data
     * @returns
     */
    login(data) {
        return http({
            url: 'user',
            method: 'PUT',
            data,
            headers: {
                notShowError: true
            }
        });
    },
    /**
     * 注册
     *
     * @param {*} data
     * @returns
     */
    register(data) {
		data.TeacherId = data.TeacherId ? parseInt(data.TeacherId) : 0;
        return http({
            url: 'user',
            method: 'POST',
            data
        });
    },
    /**
     * 获取验证码
     *
     * @param {*} data
     * @returns
     */
    getPhoneCode(data) {
        return http({
            url: 'common/GetCode',
            method: 'GET',
            params: data
        });
    },
    /**
     * 验证手机号
     *
     * @param {*} data
     * @returns
     */
    verifyCode(data) {
        return http({
            url: 'common/VerifyCode',
            method: 'GET',
            params: data
        });
    },
    /**
     * 重置密码
     *
     * @param {*} data
     * @returns
     */
    resetPassword(data) {
        return http({
            url: 'user/ResetPassword',
            method: 'PUT',
            data
        });
    },
    /**
     * 修改密码
     *
     * @param {*} data
     * @returns
     */
    changePassword(data) {
        return http({
            url: 'user/ChangePassword',
            method: 'PUT',
            data
        });
    }
};
